import * as React from 'react';
import { LoadingOutlined, CheckOutlined, EyeOutlined } from '@ant-design/icons';
import { get } from 'pc-sales/utils/http';

interface iProps {
    action: string;
    config: any;
    value: string | JSX.Element;
    callback?: Function;
    style?: any;
    className?: string;
    onlyPhone?: boolean; // 只返回号码忽略区号
    phoneCountryKey?: string; // 国家key
}

interface iState {
    value: string | JSX.Element;
    status: 'examine' | 'loading' | 'check';
}

export default class Item extends React.Component<iProps> {

    state: iState = {
        value: '',
        status: 'examine'
    };

    /**
     * 解密
     */
    decryptHandler = () => {
        const { action, config, onlyPhone, phoneCountryKey } = this.props;
        if (this.state.status === 'check') return;
        this.setState({ status: 'loading' });
        get(action, config).then((value: any) => {
            this.setState({
                value: Array.isArray(value)
                    ? onlyPhone
                        ? value[1]
                        : `(${value[0]}${phoneCountryKey ? ` ${phoneCountryKey}` : ''}) ${value[1]}`
                    : value,
                status: 'check'
            });
        }).catch((err: any) => console.log(err));
    };

    componentDidMount() {
        const { value } = this.props;
        !!value && this.setState({ value });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (JSON.stringify(nextProps.value) !== JSON.stringify(this.props.value)) {
            this.setState({ value: nextProps.value });
        }
    }

    render() {
        const { value, status } = this.state;
        const { style } = this.props;
        return (
            <span style={{display: 'flex', alignItems: 'center'}}>
                <span className="ellipsis" title={value ? `${value}` : ''}
                    style={{ marginRight: 8, display: 'inline-block', ...style }}>{value || '-'}</span>
                { !(!(String(value) || '').includes('*') && status === 'examine') &&
                    <a onClick={this.decryptHandler} style={{ fontSize: 14, verticalAlign: 'bottom' }}>
                        {{
                            'examine': <EyeOutlined />,
                            'loading': <LoadingOutlined />,
                            'check': <CheckOutlined />,
                        }[status as 'examine' | 'loading' | 'check']}
                    </a>
                }
            </span>
        );
    }
}
